import React from 'react';
import moment from 'moment';

import SVGIcon, { GENERAL_ICONS } from 'src/components/svg';

import { lang, logger } from 'src/helpers';

import TextItem from './TextItem';
import AppointmentItem from './AppointmentItem';
import AnalyseItem from './AnalyseItem';
import TimelineItem from './TimelineItem';
import TreatmentItem from './TreatmentItem';
import ReplyItem from './ReplyItem';
import CallItem from './CallItem';
import Options from './Options';
import { ExpandAnimationComponent } from 'components/Form';

const components = {
  text: TextItem,
  system: TextItem,
  audio: TextItem,
  video: TextItem,
  image: TextItem,
  appointment: AppointmentItem,
  analyse: AnalyseItem,
  timeline: TimelineItem,
  treatment: TreatmentItem,
  reply: ReplyItem,
  call: CallItem
};

export default class Message extends React.PureComponent {
  state = {
    isRemoveAll: false
  };
  warn = logger.warn.bind(logger, 'Message');

  componentDidMount() {
    let files = this.props.item?.files || [];
    files.forEach((file) => {
      if (file.file) file = file.file;
      if (!file.onUploadProgress) file.onUploadProgress = [];
      file.onUploadProgress.push(this.onUploadProgress);
    });
  }
  componentWillUnmount() {
    let files = this.props.item?.files || [];
    files.forEach((file) => {
      if (file.onUploadProgress) {
        file.onUploadProgress = file.onUploadProgress.filter((fn) => fn !== this.onUploadProgress);
      }
    });
  }
  onUploadProgress = (uploadState, file) => {
    try {
      if (uploadState?.status === 'aborted') this.forceUpdate();
    } catch (err) {
      console.log('Message onUploadProgress forceUpdate error', err, file);
    }
  };

  render() {
    let { item, own, timeMessage } = this.props;
    let side = !own ? 'left' : 'right';
    let mediaType = item.media && item.media.length === 1 && item.media[0].fileType;
    let type = item.msgType || mediaType || 'text';
    let mediaRerender = item.media?.reduce((acc, media) => {
      return acc + (media.uri?.length || 0) + (media.isDicom ? 1 : 0);
    }, 0);
    if (
      item.files?.length > 0 &&
      item.files?.every((file) => (file.file || file).uploadState?.status === 'aborted')
    ) {
      return null;
    }

    if (type === 'text' && (mediaType === 'audio' || mediaType === 'video')) type = mediaType;

    let headerTitle = null;
    if (item.forwarded)
      headerTitle = (
        <div className={'mc-forward'}>
          <SVGIcon iconname={GENERAL_ICONS.FORWARD} />
          <span>{lang.t('Forwarded')}</span>
        </div>
      );
    if (item.replyTo) type = 'reply';

    if (!components[type]) {
      this.warn('unknown msg type', type, item);
      type = 'text';
    }

    let Component = components[type];
    if (['timeline', 'treatment', 'analyse', 'reply', 'call'].indexOf(type) > -1) {
      return (
        <ExpandAnimationComponent key={'msg-' + item.id} show={!item.isRemoved} dropdown={false}>
          {timeMessage && (
            <div className={'mc-mt10 mc-pl10 mc-flex'}>
              <div className={'mc-grow mc-b2t'}></div>
              <div className={'mc-label-416'}>{timeMessage}</div>
              <div className={'mc-grow mc-b2t'}></div>
            </div>
          )}
          <div className={`mc-chat-msg`}>
            <div className={`mc-text-msg  mc-${type}-msg mc-${side}`}>
              <Options {...this.props} type={type} />
              <div className={'mc-flex-5-col'}>
                {headerTitle}
                <Component
                  {...this.props}
                  side={side}
                  type={type}
                  msg={item}
                  state={item.state}
                  fromChat={true}
                  mediaRerender={mediaRerender}
                />
              </div>

              <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
                <div className={'mc-send'}>
                  <SVGIcon iconname={'send-status-icon'} state={item.state} />
                </div>
                <div className={'mc-time'}>{item.date && moment(item.date).format('hh:mm A')}</div>
              </div>
            </div>
          </div>
        </ExpandAnimationComponent>
      );
    }
    return (
      <ExpandAnimationComponent key={'msg-' + item.id} show={!item.isRemoved} dropdown={false}>
        {timeMessage && (
          <div className={'mc-mt10 mc-pl10 mc-flex'}>
            <div className={'mc-grow mc-b2t'}></div>
            <div className={'mc-label-416'}>{timeMessage}</div>
            <div className={'mc-grow mc-b2t'}></div>
          </div>
        )}
        <div className={'mc-chat-msg'} key={'msg-' + item.id}>
          <Component
            {...this.props}
            side={side}
            type={type}
            msg={item}
            state={item.state}
            renderOptions={<Options {...this.props} type={type} />}
            headerTitle={headerTitle}
            mediaRerender={mediaRerender}
          />
        </div>
      </ExpandAnimationComponent>
    );
  }
}
